import { createFetch, isObject, toValue } from '@vueuse/core';
import queryString from 'query-string';
import { serialize } from 'object-to-formdata';

import { closeToast, showToast } from 'vant';
import 'vant/es/toast/style';

import { CustomHeaders, getDefaultHeaders } from './header.js';
import { STORAGE_TOKEN_KEY } from '@local-utils/const';

/**
 *
 * @param url {import('@vueuse/core').MaybeRefOrGetter<string> | {url: import('@vueuse/core').MaybeRefOrGetter<string>, data?: import('@vueuse/core').MaybeRefOrGetter<string, any>}}
 * @param options {RequestInit, {
 *   raw?: boolean,
 *   toast?: boolean,
 * }=}
 * @param useFetchOptions {import('@vueuse/core').UseFetchOptions=}
 */
export function useRequest(url, options, useFetchOptions) {
  let data = null;

  if (isObject(toValue(url))) {
    data = url.data;
    url = url.url;
  }

  options = {
    raw: false,
    toast: true,
    ...options,
  };

  const useFetchReturn = createFetch({
    options: {
      timeout: 60 * 1000,
      beforeFetch(ctx) {
        const { url, options } = ctx;
        options.headers = {
          ...getDefaultHeaders(),
          ...CustomHeaders,
          ...options.headers,
        };

        if (data) {
          switch (options.method.toUpperCase()) {
            case 'GET':
            case 'PUT':
              ctx.url = queryString.stringifyUrl({
                url,
                query: toValue(data),
              });
              break;
            default:
              if (options.is_serialize === false) {
                options.body = toValue(data);
              } else {
                options.body = serialize(toValue(data));
              }
          }
        }

        return ctx;
      },
      afterFetch(ctx) {
        const { data } = ctx;

        if (!isObject(data)) {
          throw new Error('Server Error');
        }

        // 如果设置了 skipCodeCheck，跳过 code 检查，直接返回数据
        // 第三方登录没有返回code
        if (options.skipCodeCheck) {
          if (!options.raw) {
            // 如果数据有 data 字段，提取 data 字段；否则返回整个数据对象
            ctx.data = data.data !== undefined ? data.data : data;
          }
          return ctx;
        }

        // 正常的code
        if ([1, 200].includes(data.code)) {
          if (!options.raw) {
            ctx.data = data.data;
          }
          return ctx;
        }

        // token相关的异常
        if ([1007, 1010, 3303, 101001].includes(data.code)) {
          localStorage.removeItem(STORAGE_TOKEN_KEY);
        }

        throw new Error(`Code：${data.code}`);
      },
      onFetchError(ctx) {
        console.error('onFetchError', ctx);

        const { data } = ctx;
        if (!isObject(data)) {
          return ctx;
        }

        if (options.toast) {
          closeToast();
          showToast({
            duration: 1500,
            message: data?.msg || data?.message || ctx.error.message || '请稍后重试',
          });
        }

        ctx.error = data;
        return ctx;
      },
    },
  })(url, options, useFetchOptions);

  // 设置默认json返回
  useFetchReturn.json();

  return useFetchReturn;
}
